import { AdvancedMethodsRMTesting } from '../enums';
import { Exercise } from './exercise';
import { DeclaredState, FitnessState } from './user-state';

/**
 * Whether this exercise finds its training weight by a strength test (a one-rep-max test) for
 * this user. The user's own choice for the exercise wins; otherwise their general setting
 * decides, and an exercise marked as unsuited to such a test is left out.
 *
 * Lives in shared, like the myo-rep helpers, so code with no Angular in it can ask the question
 * and a unit test can reach it. `services/exercise-db.service` re-exports it, so existing imports
 * keep working.
 */
export function exerciseUsesRMTesting(exercise: Exercise, declaredState: DeclaredState, fitnessState: FitnessState): boolean {
  let exerciseStats = fitnessState.exerciseStats[exercise._id];
  let preferredByUser = exerciseStats && exerciseStats.preferRMTesting;
  if (preferredByUser === AdvancedMethodsRMTesting.Prefer) {
    return true;
  } else if (preferredByUser === AdvancedMethodsRMTesting.Avoid) {
    return false;
  }

  switch (declaredState.advancedMethodsRMTesting) {
    case undefined: default: // for cases where this was not set yet
      return true;
    case AdvancedMethodsRMTesting.Avoid:
      return false;
    case AdvancedMethodsRMTesting.Automatic:
      return !exercise.avoidRMTesting;
    case AdvancedMethodsRMTesting.Prefer:
      return !exercise.avoidRMTesting;
  }
}
